module.exports = __webpack_public_path__ + "static/img/3-CN-old.3bedbed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/3-CN-old.png
// module id = BGi9
// module chunks = 1